import React from 'react';

// Tonos semánticos únicos para toda la app. No agregar colores decorativos nuevos:
// success = aprobado/completado, warning = pendiente, danger = error/rechazado,
// info = informativo, neutral = borrador/inactivo.
const TONE_CLASSES = {
  success: 'bg-success-50 text-success-700 border-success-100',
  warning: 'bg-warning-50 text-warning-700 border-warning-100',
  danger: 'bg-danger-50 text-danger-700 border-danger-100',
  info: 'bg-info-50 text-info-700 border-info-100',
  neutral: 'bg-neutral-100 text-neutral-600 border-neutral-200',
};

const Badge = ({ tone = 'neutral', children, className = '' }) => {
  const toneClass = TONE_CLASSES[tone] || TONE_CLASSES.neutral;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-sm border text-xs font-medium whitespace-nowrap ${toneClass} ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
